<template>
  <v-container>
    <v-card>
      <v-card-title class="cyan darken-1 white--text text-h6">
        {{ $t('accueil.documentsCiem.titre') }}
      </v-card-title>
      <v-row class="pa-4" justify="space-between">
        <v-col cols="3">
          <v-treeview
            :active.sync="active"
            :items="items"
            :open.sync="open"
            activatable
            color="warning"
            open-all
            transition
            class="specific"
          >
            <template v-slot:prepend="{ item }">
              <v-icon v-if="!item.children"> mdi-file-document </v-icon>
            </template>
          </v-treeview>
        </v-col>

        <v-divider vertical></v-divider>

        <v-col cols="9" class="d-flex text-center">
          <v-scroll-y-transition mode="out-in">
            <div
              v-if="!selected"
              class="text-h6 grey--text text--lighten-1 font-weight-light"
              style="align-self: center"
            >
              Selectionner un document
            </div>
            <v-card
              v-else
              :key="selected.id"
              class="pt-6 mx-auto"
              flat
              width="100%"
            >
              <pdf-app :currentDocument="currentDocument" />
            </v-card>
          </v-scroll-y-transition>
        </v-col>
      </v-row>
    </v-card>

    <!-- <v-dialog v-model="visualisePDF" scrollable max-width="100%">
      <v-card>
        <v-card-title class="headline pink white--text">
          {{ currentDocument.fileName }}
        </v-card-title>

        <v-card-text style="height: 600em;">
          <vue-pdf-app
            :pdf="currentDocument.contentDocument"
            :file-name="currentDocument.fileName"
          />
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn @click="visualisePDF = false">
            {{ $t('button.close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->
  </v-container>
</template>

<script>
import Api from '@/utils/api'
import toasted from '@/utils/toasted'
import _ from 'lodash'

const scoped = {
  data: null,
}

export default {
  beforeRouteEnter(to, from, next) {
    new Api('get-documents-ciem')
      .get()
      .then((response) => {
        scoped.data = response.body
        next()
      })
      .catch(() => {
        toasted.error('documentciem.telechargement.error')
        next()
      })
  },
  data: () => ({
    visualisePDF: false,
    active: [],
    open: [],
    documents: [],
    currentDocument: {
      contentDocument: null,
      fileName: null,
    },
  }),
  mounted() {
    if (scoped.data) {
      this.documents = scoped.data
      if (!_.isEmpty(this.documents)) {
        this.active.push(this.documents[0].id)
      }
    }
  },
  computed: {
    items() {
      return [
        {
          name: 'Informations légales',
          children: this.documents,
        },
      ]
    },
    selected() {
      if (!this.active.length) return undefined

      const id = this.active[0]

      const retour = this.documents.find((document) => document.id === id)
      if (retour) {
        const binaryString = window.atob(retour.data) // Comment this if not using base64
        const bytes = new Uint8Array(binaryString.length)
        const mappedData = bytes.map((byte, i) => binaryString.charCodeAt(i))
        this.fetchDocuments(mappedData.buffer, retour.libelle)
        // this.currentDocument.contentDocument = mappedData.buffer;
        // this.currentDocument.fileName = retour.libelle;
      }
      return retour
    },
  },

  watch: {},

  methods: {
    fetchDocuments(tt, rr) {
      this.currentDocument.contentDocument = tt
      this.currentDocument.fileName = rr
      // this.visualisePDF = true;
    },
  },
}
</script>
<style>
.v-treeview-node__label {
  white-space: normal !important;
}
</style>
